import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import Form from '@piconetworks/pkg-form';

var _excluded = ["fieldContainerProps", "description", "required", "input", "options"];
var Radio = function Radio(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref,
    fieldContainerProps = _ref2.fieldContainerProps,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description,
    required = _ref2.required;
    _ref2.input;
    var _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? [] : _ref2$options,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("p", null, description), options.map(function (_ref3, idx) {
    var label = _ref3.label;
    return /*#__PURE__*/React.createElement(Field, _extends({
      key: idx,
      component: Form.Radio,
      type: "radio",
      text: label,
      value: label
    }, required && {
      validate: function validate(value) {
        return value ? undefined : 'Required';
      }
    }, rest));
  }));
};
Radio.propTypes = {
  fieldContainerProps: PropTypes.any,
  description: PropTypes.string,
  required: PropTypes.bool,
  previewMode: PropTypes.bool,
  input: PropTypes.any
};

export { Radio as default };
//# sourceMappingURL=index.js.map
